import React, { useEffect, useRef } from 'react'
import { CloseOutlined, RobotOutlined, SendOutlined, UserOutlined } from '@ant-design/icons'
import { Avatar } from 'antd'
import c from 'classnames'
import { LlmChatMessageSenderType } from '@/__gen/types'
import style from './messages.module.sass'
import { MarkdownMessage } from './markdown-message'
import { useLlm } from './useLlm'

const DEFAULT_MESSAGE = {
	id: 'default',
	content: "Welcome. Let me know how you'd like to get started, or choose one of the options below.",
	sender: LlmChatMessageSenderType.Agent,
	created: new Date().toISOString(),
	responseReceivedAt: new Date().toISOString(),
}

export const Messages = ({ messages }: { messages: ReturnType<typeof useLlm>['messages'] }) => {
	const formatTime = (date: Date) => {
		return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
	}
	const messagesEndRef = useRef<HTMLDivElement>(null)

	const scrollToBottom = () => {
		messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' })
	}
	useEffect(() => {
		scrollToBottom()
	}, [messages])
	return (
		<div className={style.chatContainer}>
			<div className={style.messagesContainer}>
				{[DEFAULT_MESSAGE, ...messages].map((message) => (
					<div
						key={message.id}
						className={c(style.messageRow, {
							[style.userMessage]: message.sender == LlmChatMessageSenderType.User,
							[style.aiMessage]: message.sender == LlmChatMessageSenderType.Agent,
						})}
					>
						<div className={style.messageContent}>
							<div className={style.messageText}>
								<MarkdownMessage content={message.content} />
								{message.sender == LlmChatMessageSenderType.Agent && message.responseReceivedAt === null && (
									<div className={style.typingIndicator}>
										<span></span>
										<span></span>
										<span></span>
									</div>
								)}
							</div>
							<div className={style.messageTime}>{formatTime(new Date(message.created))}</div>
						</div>
					</div>
				))}
				<div ref={messagesEndRef} />
			</div>
		</div>
	)
}
